import { fromJS } from 'immutable';

export const ADD_MESSAGE = 'ADD_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
export const DISMISS_MESSAGE = 'DISMISS_MESSAGE';

const initialState = fromJS({
  messages: [],
});

const removeMessage = (state, id) => {
  const messages = state.get('messages');
  const index = messages.findIndex(m => id === m.get('id'));
  if (index >= 0) {
    return state.set('messages', messages.delete(index));
  }
  return state;
};

const dismissMessage = (state, id) => {
  const messages = state.get('messages');
  const index = messages.findIndex(m => id === m.get('id'));
  if (index >= 0) {
    return state.set('messages', messages.update(index, m => m.set('visible', false)));
  }
  return state;
};

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const messageReducer = (state = initialState, {
  type, messageType, message, id,
}) => {
  switch (type) {
    case CLEAR_MESSAGES:
      return initialState;
    case ADD_MESSAGE:
      return state.set('messages', state.get('messages').push(fromJS({
        id,
        message,
        visible: true,
        type: messageType,
      })));
    case REMOVE_MESSAGE:
      return removeMessage(state, id);
    case DISMISS_MESSAGE:
      return dismissMessage(state, id);
    default:
      return state;
  }
};
